import { defineSlotRecipe } from "@pandacss/dev";

export const aromaContextualMenu = defineSlotRecipe({
  className: "aroma-contextual-menu",
  jsx: ["ContextualMenu", "ContextualMenuItem"],
  slots: ["itemGroupLabel", "item", "content", "action", "secondaryAction"],
  base: {
    itemGroupLabel: {
      textStyle: "title.xs",
      height: "xl",
      display: "flex",
      px: "padding.2",
      alignItems: "center",
      color: "content.neutral.base.subtle",
    },
    item: {
      textStyle: "paragraph.m.bold",
      color: "content.neutral.base.bold",
      display: "flex",
      gap: "gap.2",
      px: "padding.3",
      borderRadius: "l",
      height: "xl",
      alignItems: "center",
      cursor: "pointer",
      _aromaticonChildren: {
        fontSize: "{sizes.xs}",
      },
      _notDisabled: {
        _hover: {
          bgColor: "background.neutral.base.subtlest-hover",
        },
      },
      _highlighted: {
        outlineWidth: "m",
        outlineStyle: "solid",
        outlineColor: "border.brand",
        shadow: "effect.focus-ring.brand",
        _notDisabled: {
          _hover: {
            outline: "none",
            shadow: "none",
          },
        },
      },
      _disabled: {
        color: "content.neutral.base.disable",
        cursor: "no-drop",
        pointerEvents: "none",
      },
    },
    content: {
      width: "width.3xs",
      bgColor: "background.neutral.base.subtlest",
      borderRadius: "l",
      borderWidth: "m",
      borderStyle: "solid",
      borderColor: "border.neutral.subtle",
      shadow: "effect.shadow.subtle-bottom",
      display: "flex",
      flexDirection: "column",
      _open: {
        animation: "fadeIn 0.25s ease-out",
      },
      _closed: {
        animation: "fadeOut 0.2s ease-out",
      },
      _focusVisible: {
        outline: "none",
      },
      '&:has([data-icon="true"])': {
        width: "unset",
      },
    },
    action: {
      width: "auto",
      margin: "padding.3",
      marginTop: "padding.2",
    },
    secondaryAction: {
      width: "auto",
      marginTop: "-padding.1",
      margin: "padding.3",
    },
  },
});
